var map = {
	"./2018-03-04/whats-new.html": 2298,
	"./2018-04-12/whats-new.html": 2299,
	"./2018-04-24/whats-new.html": 2300,
	"./2018-05-23/whats-new.html": 2301,
	"./2018-05-31/whats-new.html": 2302,
	"./2018-07-04/whats-new.html": 2303,
	"./2018-07-19/whats-new.html": 2304,
	"./2018-11-20/whats-new.html": 2305,
	"./2019-04-04/whats-new.html": 2306,
	"./2020-01-21/whats-new.html": 2307,
	"./2020-07-18/whats-new.html": 2308,
	"./2021-06-10/whats-new.html": 2309,
	"./2021-07-26/whats-new.html": 2310,
	"./2021-08-26/whats-new.html": 2311,
	"./2021-12-07/whats-new.html": 2312,
	"./2022-06-03/whats-new.html": 2313,
	"./2022-09-08/whats-new.html": 2314,
	"./2023-01-01/whats-new.html": 2315,
	"./2023-06-14/whats-new.html": 2316,
	"./2024-10-31/whats-new.html": 2317,
	"./2024-12-12/whats-new.html": 2318,
	"./2026-02-04/whats-new.html": 2319
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2297;


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/whats-new/update ^\.\/.*\/whats\-new\.html$
// module id = 2297
// module chunks = 0